import { mapToStyles, mergeStyles } from '@coolblue-development/freddy';
const getFullWidthStyles = (fullWidth) => {
    return {
        width: fullWidth ? '100%' : 'auto',
        display: fullWidth ? 'block' : 'inline-block',
    };
};
export const getAnchorBarStyles = (fullWidth, theme) => {
    return mergeStyles([
        {
            borderBottom: `1px solid ${theme.color.border.interactiveBase}`,
            marginBottom: theme.spacing[500],
        },
        fullWidth ? mapToStyles(fullWidth, getFullWidthStyles) : {},
    ]);
};
//# sourceMappingURL=AnchorBar.styles.js.map